/* Native Shopify enhancement. Passwords are handled exclusively by Shopify's form. */
(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const strings = JSON.parse($('#ThemeStrings')?.textContent || '{}');
  const body = document.body;
  const rootUrl = body.dataset.root || '/';
  const cartUrl = body.dataset.cartUrl || `${rootUrl}cart`;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const announce = text => { const node = $('#LiveStatus'); if (node) node.textContent = text; };
  const motionMs = () => reducedMotion.matches ? 0 : (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--motion')) || 0);
  const opener = new WeakMap();
  function openDialog(dialog, trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    $$('dialog[open]').filter(node => node !== dialog).forEach(closeDialog);
    if (trigger) opener.set(dialog, trigger);
    if (!dialog.open) dialog.showModal();
    trigger?.setAttribute('aria-expanded', 'true');
    return true;
  }
  function closeDialog(dialog) {
    if (!dialog?.open) return;
    dialog.close();
    opener.get(dialog)?.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-dialog-open]');
    if (open) openDialog(document.getElementById(open.dataset.dialogOpen), open);
    const close = event.target.closest('[data-dialog-close]');
    if (close) closeDialog(close.closest('dialog'));
    const back = event.target.closest('[data-password-back]');
    if (back) { const details = back.closest('details'); details.open = false; $('summary', details).focus(); }
    if (event.target instanceof HTMLDialogElement && !event.target.matches('[data-entrance]')) {
      const r = event.target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(event.target);
    }
  });
  document.addEventListener('close', event => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    const trigger = opener.get(event.target);
    trigger?.setAttribute('aria-expanded', 'false');
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  }, true);
  const entranceKey = `entrance:${location.host}`;
  const passwordTransitKey = `${entranceKey}:password-submit`;
  function clearPasswordTransit() {
    try { sessionStorage.removeItem(passwordTransitKey); } catch {}
    document.cookie = 'coeda_entrance_submit=; Max-Age=0; Path=/; SameSite=Lax; Secure';
  }
  function passwordEntrance(scope = document) {
    if ($('[data-entrance=password]', scope)) clearPasswordTransit();
    $$('.entrance-details', scope).forEach(details => {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      const focusInput = () => { if (details.open) $('input[type=password]', details)?.focus({ preventScroll: true }); };
      details.addEventListener('toggle', focusInput);
      if (details.open) focusInput();
    });
  }
  document.addEventListener('submit', event => {
    if (event.defaultPrevented || !event.target.matches('#StorefrontPassword')) return;
    try { sessionStorage.setItem(passwordTransitKey, String(Date.now())); }
    catch { document.cookie = `coeda_entrance_submit=${Date.now()}; Max-Age=600; Path=/; SameSite=Lax; Secure`; }
  });
  function consumePasswordTransit() {
    if (!$('#Storefront')) return false;
    let submitted = 0;
    try { submitted = Number(sessionStorage.getItem(passwordTransitKey)); } catch {}
    if (!submitted) submitted = Number(document.cookie.split('; ').find(value => value.startsWith('coeda_entrance_submit='))?.split('=')[1]);
    clearPasswordTransit();
    const arriving = submitted > 0 && Date.now() - submitted >= 0 && Date.now() - submitted < 600000;
    if (arriving) { try { sessionStorage.setItem(entranceKey, 'entered'); } catch {} }
    return arriving;
  }
  function publicEntrance() {
    const fromPassword = consumePasswordTransit();
    const gate = $('#PublicEntrance');
    if (!gate) return;
    if (fromPassword) return;
    const key = entranceKey;
    let entered = false;
    try { entered = sessionStorage.getItem(key) === 'entered'; } catch { /* Privacy mode: continue without persistence. */ }
    if (gate.dataset.entrance === 'session' && entered && !gate.querySelector('[data-presale-result]') && new URLSearchParams(location.search).get('presale') !== '1') return;
    if (!openDialog(gate)) return;
    gate.addEventListener('cancel', event => event.preventDefault());
    $('[data-enter-public]', gate).addEventListener('click', () => {
      try { sessionStorage.setItem(key, 'entered'); } catch { /* The public entrance is cosmetic, never access control. */ }
      gate.classList.add('is-leaving');
      setTimeout(() => { gate.close(); $('#MainContent')?.focus({ preventScroll: true }); }, motionMs());
    }, { once: true });
  }
  const countdowns = new Map();
  function entranceCountdown(scope = document) {
    $$('[data-countdown-end]', scope).forEach(node => {
      if (countdowns.has(node)) return;
      const value = node.dataset.countdownEnd.trim();
      const deadline = /T.*(?:Z|[+-]\d{2}:\d{2})$/i.test(value) ? Date.parse(value) : NaN;
      if (!Number.isFinite(deadline)) return;
      countdowns.set(node, deadline);
    });
    tickCountdowns();
  }
  let countdownTimer;
  function tickCountdowns() {
    clearTimeout(countdownTimer);
    let running = false;
    for (const [node, deadline] of countdowns) {
      if (!node.isConnected) { countdowns.delete(node); continue; }
      const left = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      const values = { days: Math.floor(left / 86400), hours: Math.floor(left / 3600) % 24, minutes: Math.floor(left / 60) % 60, seconds: left % 60 };
      for (const [unit, value] of Object.entries(values)) {
        const output = $(`[data-countdown-${unit}]`, node);
        const text = String(value).padStart(2, '0');
        if (output && output.textContent !== text) output.textContent = text;
      }
      node.hidden = false;
      running ||= left > 0 && (!node.closest('dialog') || node.closest('dialog').open);
    }
    if (running && !document.hidden) countdownTimer = setTimeout(tickCountdowns, 1000);
  }
  document.addEventListener('visibilitychange', tickCountdowns);
  window.addEventListener('pageshow', tickCountdowns);
  window.addEventListener('pagehide', () => clearTimeout(countdownTimer));
  document.addEventListener('close', tickCountdowns, true);
  let cartBusy = false;
  let cartNoteDraft = null;
  let cartRead = null;
  function cartSections() {
    const page = $('[data-cart-page]')?.closest('[id^="shopify-section-"]');
    return ['cart-drawer', ...(page ? [page.id.replace('shopify-section-', '')] : [])];
  }
  const setCartError = message => $$('[data-cart-error]').forEach(node => { node.textContent = message; });
  function setCartBusy(busy) {
    cartBusy = busy;
    $$('[data-cart-content]').forEach(node => {
      node.setAttribute('aria-busy', String(busy));
      $$('button, input, textarea', node).forEach(control => {
        if (busy && !control.disabled) { control.disabled = true; control.dataset.cartLocked = 'true'; }
        else if (!busy && control.dataset.cartLocked) { control.disabled = false; delete control.dataset.cartLocked; }
      });
    });
  }
  function renderCart(sections) {
    const html = sections?.['cart-drawer'];
    if (!html) return false;
    const fragment = new DOMParser().parseFromString(html, 'text/html');
    const content = $('[data-cart-content]', fragment);
    const drawerContent = $('#CartDrawer [data-cart-content]');
    if (!content || !drawerContent) return false;
    drawerContent.replaceWith(content);
    $$('[data-cart-count]').forEach(node => { node.textContent = content.dataset.count || '0'; });
    for (const [id, sectionHTML] of Object.entries(sections)) {
      if (id === 'cart-drawer' || !sectionHTML) continue;
      const existing = document.getElementById(`shopify-section-${id}`);
      const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
      const next = $('[data-cart-page]', parsed);
      if (existing && next) existing.replaceChildren(next);
    }
    if (cartNoteDraft !== null) $$('[data-cart-content] textarea[name=note]').forEach(node => { node.value = cartNoteDraft; });
    return true;
  }
  document.addEventListener('input', event => {
    if (event.target.matches('[data-cart-content] textarea[name=note]')) {
      cartNoteDraft = event.target.value;
      $$('[data-cart-content] textarea[name=note]').forEach(node => { node.value = cartNoteDraft; });
    }
  });
  async function readCart() {
    const url = new URL(cartUrl, location.origin);
    url.searchParams.set('sections', cartSections().join(','));
    const response = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(strings.cartError);
    if (!renderCart(await response.json())) throw new Error(strings.cartError);
  }
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-cart-open]');
    if (!trigger) return;
    if (!openDialog($('#CartDrawer'), trigger)) return;
    event.preventDefault();
    if (cartBusy) return;
    setCartError('');
    if (!cartRead) cartRead = readCart().catch(error => setCartError(error.message || strings.cartError)).finally(() => { cartRead = null; });
    await cartRead;
  });
  async function mutateCart(url, options) {
    if (cartRead) await cartRead;
    const response = await fetch(url, { ...options, credentials: 'same-origin', headers: { Accept: 'application/json', ...(options.headers || {}) } });
    let result;
    try { result = await response.json(); } catch { throw new Error(strings.cartError); }
    if (!response.ok || result.status >= 400) {
      try { await readCart(); } catch { /* Keep the original API error visible. */ }
      throw new Error(result.description || result.message || strings.cartError);
    }
    if (!renderCart(result.sections)) await readCart();
    return result;
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.product-form');
    if (!form || !window.fetch || !$('#CartDrawer')) return;
    if (cartBusy) { event.preventDefault(); return; }
    const submit = $('[data-add-to-cart]', form);
    if (!submit || submit.disabled) { event.preventDefault(); return; }
    event.preventDefault();
    const data = new FormData(form);
    data.set('sections', cartSections().join(','));
    data.set('sections_url', cartUrl);
    const errorNode = $('[data-product-error]', form);
    const label = submit.textContent;
    errorNode.textContent = '';
    submit.disabled = true; submit.textContent = strings.adding || 'ADDING…';
    setCartBusy(true); setCartError('');
    try {
      await mutateCart(`${body.dataset.addUrl || `${rootUrl}cart/add`}.js`, { method: 'POST', body: data });
      openDialog($('#CartDrawer'), submit);
      announce(strings.added);
    } catch (error) { errorNode.textContent = error.message || strings.productError; }
    finally { setCartBusy(false); submit.disabled = false; submit.textContent = label; }
  });
  async function changeLine(control, quantity) {
    if (cartBusy) return;
    if (!Number.isSafeInteger(quantity) || quantity < 0) { setCartError(strings.cartError); return; }
    const context = control.closest('[data-cart-page]') ? 'page' : 'drawer';
    const key = control.dataset.key;
    const serverQuantity = control.dataset.serverQuantity;
    setCartBusy(true); setCartError('');
    try {
      await mutateCart(`${body.dataset.changeUrl || `${rootUrl}cart/change`}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: cartSections(), sections_url: cartUrl })
      });
      announce(strings.cartUpdated);
    } catch (error) {
      setCartError(error.message || strings.cartError);
      if (control.isConnected && serverQuantity !== undefined) control.value = serverQuantity;
    }
    finally {
      setCartBusy(false);
      const scope = context === 'page' ? $('[data-cart-page]') : $('#CartDrawer');
      const next = $$('[data-cart-quantity]', scope).find(node => node.dataset.key === key);
      (next || $('[data-dialog-close]', scope) || $('h1', scope))?.focus({ preventScroll: true });
    }
  }
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-quantity]');
    if (input) { if (input.value === '' || !input.checkValidity()) return; changeLine(input, Number(input.value)); }
    const sort = event.target.closest('[data-sort]');
    if (sort) { const url = new URL(location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page'); location.assign(url); }
  });
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); changeLine(remove, 0); }
  });
  // Shopify resolves each option combination, including products above 250 variants.
  const productRequests = new WeakMap();
  document.addEventListener('click', async event => {
    const option = event.target.closest('[data-option-link]');
    if (!option || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const section = option.closest('[data-product-section]');
    if (!section || !window.fetch) return;
    event.preventDefault();
    if (cartBusy) return;
    if (section.hasAttribute('aria-busy')) return;
    const last = productRequests.get(section);
    last?.abort();
    const controller = new AbortController();
    productRequests.set(section, controller);
    const url = new URL(option.href);
    if (url.origin !== location.origin) { location.assign(url); return; }
    const sectionURL = new URL(url);
    sectionURL.searchParams.set('section_id', section.dataset.productSection);
    const errorNode = $('[data-product-error]', section);
    const submit = $('[data-add-to-cart]', section);
    const quantity = $('[name=quantity]', section)?.value;
    const focusId = option.dataset.optionId;
    const position = option.dataset.optionPosition;
    section.setAttribute('aria-busy', 'true');
    if (submit) submit.disabled = true;
    errorNode.textContent = '';
    try {
      const response = await fetch(sectionURL, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(strings.variantError);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = $('[data-product-section]', doc);
      if (!next) throw new Error(strings.variantError);
      if (controller.signal.aborted) return;
      const nextQty = $('[name=quantity]', next);
      if (nextQty && quantity) {
        nextQty.value = quantity;
        if (!nextQty.checkValidity()) nextQty.value = nextQty.min || '1';
      }
      section.replaceWith(next);
      document.dispatchEvent(new CustomEvent('coeda:product-updated'));
      const variant = next.dataset.selectedVariant;
      if (variant) { url.searchParams.delete('option_values'); url.searchParams.set('variant', variant); }
      history.replaceState({}, '', url.pathname + url.search + url.hash);
      const focus = $$('[data-option-link]', next).find(node => node.dataset.optionId === focusId && node.dataset.optionPosition === position);
      focus?.focus({ preventScroll: true });
      const selectedMedia = next.dataset.selectedMedia;
      if (selectedMedia && !reducedMotion.matches) $(`[data-media-id="${CSS.escape(selectedMedia)}"]`, next)?.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    } catch (error) {
      if (error.name !== 'AbortError') {
        errorNode.textContent = strings.variantError || 'Unable to load option. Reload the page and try again.';
        if (submit) submit.disabled = !$('[name=id]:not(:disabled)', section);
      }
    } finally { if (productRequests.get(section) === controller) section.removeAttribute('aria-busy'); }
  });
  // Pointer deltas are transient layout preferences only. Linked images retain clicks.
  const dragState = new WeakMap();
  let dragLayer = 21;
  function initDrag(scope = document) {
    $$('[data-canvas]', scope).forEach(canvas => {
      if (canvas.dataset.initialized || canvas.dataset.dragEnabled !== 'true') return;
      canvas.dataset.initialized = 'true';
      $$('[data-draggable=true]', canvas).forEach(item => {
        const state = { x: 0, y: 0, active: false, moved: false };
        dragState.set(item, state);
        const touchDisabled = () => matchMedia('(pointer:coarse), (max-width:749px)').matches && item.dataset.mobileDrag !== 'true';
        const draw = (x, y) => {
          if (item.dataset.bounded === 'true') {
            const area = canvas.getBoundingClientRect(), r = item.getBoundingClientRect();
            const baseX = r.left - area.left - state.x, baseY = r.top - area.top - state.y;
            x = Math.max(-baseX, Math.min(x, area.width - r.width - baseX));
            y = Math.max(-baseY, Math.min(y, area.height - r.height - baseY));
          }
          state.x = x; state.y = y;
          item.style.setProperty('--drag-x', `${x}px`); item.style.setProperty('--drag-y', `${y}px`);
        };
        const reset = () => { state.x = state.y = 0; item.style.removeProperty('--drag-x'); item.style.removeProperty('--drag-y'); item.style.removeProperty('z-index'); };
        state.reset = reset;
        item.addEventListener('pointerdown', event => {
          if (event.button !== 0 || touchDisabled()) return;
          state.startX = event.clientX; state.startY = event.clientY; state.baseX = state.x; state.baseY = state.y;
          state.active = true; state.moved = false;
          state.pointerId = event.pointerId;
        });
        item.addEventListener('pointermove', event => {
          if (!state.active || state.pointerId !== event.pointerId) return;
          const dx = event.clientX - state.startX, dy = event.clientY - state.startY;
          if (!state.moved && Math.hypot(dx, dy) < 5) return;
          if (!state.moved) { item.setPointerCapture(event.pointerId); item.style.zIndex = String(++dragLayer); }
          state.moved = true; item.classList.add('is-dragging'); event.preventDefault();
          draw(state.baseX + dx, state.baseY + dy);
        });
        const finish = event => { state.active = false; item.classList.remove('is-dragging'); if (item.hasPointerCapture(event.pointerId)) item.releasePointerCapture(event.pointerId); };
        item.addEventListener('pointerup', finish);
        item.addEventListener('pointercancel', finish);
        item.addEventListener('lostpointercapture', () => { state.active = false; item.classList.remove('is-dragging'); });
        item.addEventListener('click', event => { if (state.moved) { event.preventDefault(); event.stopPropagation(); state.moved = false; } }, true);
        item.addEventListener('dragstart', event => event.preventDefault());
        $('.drag-handle', item)?.addEventListener('keydown', event => {
          if (touchDisabled()) return;
          if (event.key === 'Escape') { event.preventDefault(); reset(); return; }
          const direction = { ArrowLeft: [-1,0], ArrowRight: [1,0], ArrowUp: [0,-1], ArrowDown: [0,1] }[event.key];
          if (!direction) return;
          event.preventDefault(); const step = event.shiftKey ? 30 : 10;
          item.style.zIndex = String(++dragLayer); draw(state.x + direction[0] * step, state.y + direction[1] * step);
        });
        if (item.dataset.mobileDrag === 'true') item.style.touchAction = 'none';
        const mq = matchMedia('(max-width:749px)'); mq.addEventListener('change', reset);
      });
      $('[data-reset-media]', canvas)?.addEventListener('click', () => $$('[data-draggable]', canvas).forEach(item => dragState.get(item)?.reset()));
    });
  }
  function initCursor() {
    if (body.dataset.cursor !== 'cross') return;
    const cursor = $('.cursor-cross');
    const pointer = matchMedia('(hover:hover) and (pointer:fine)');
    const enabled = () => pointer.matches && !reducedMotion.matches;
    const update = () => { body.classList.toggle('cursor-ready', enabled()); };
    pointer.addEventListener('change', update); reducedMotion.addEventListener('change', update); update();
    let frame = 0, x = 0, y = 0;
    document.addEventListener('pointermove', event => {
      if (!enabled() || !cursor) return;
      x = event.clientX; y = event.clientY;
      cursor.classList.add('is-visible');
      cursor.classList.toggle('is-active', Boolean(event.target.closest('a,button,summary')));
      if (!frame) frame = requestAnimationFrame(() => { cursor.style.transform = `translate3d(${x}px,${y}px,0)`; frame = 0; });
    });
    document.documentElement.addEventListener('pointerleave', () => cursor?.classList.remove('is-visible'));
    window.addEventListener('blur', () => cursor?.classList.remove('is-visible'));
  }
  document.addEventListener('shopify:section:load', event => { passwordEntrance(event.target); entranceCountdown(event.target); initDrag(event.target); });
  document.addEventListener('shopify:section:unload', event => $$('dialog[open]', event.target).forEach(closeDialog));
  window.addEventListener('pageshow', event => { if (event.persisted && $('#CartDrawer')) { $$('dialog[open]:not([data-entrance])').forEach(closeDialog); readCart().catch(() => {}); } });
  let resizeFrame = 0;
  window.addEventListener('resize', () => {
    if (resizeFrame) cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      $$('[data-draggable][data-bounded=true]').forEach(item => dragState.get(item)?.reset());
      resizeFrame = 0;
    });
  });
  passwordEntrance(); publicEntrance(); entranceCountdown(); initDrag(); initCursor();
})();
